<template>
  <div id="index">

    <div v-if="idloading">
      <div class="spinner-box">
        <img src="@/assets/img/loadding_pc.gif" alt="">
      </div>
    </div>
    <div class="main wrap">
      <div class="recommended">
        <div class="recommended_head">
          <div class="recommended_title">
            <el-page-header @back="goBackward" :content="detail.title">
            </el-page-header>
          </div>
          <div class="head_bottom flex_between">
            <div class="flex_center head_left">
              <span class="original">原创：{{ detail.user }}</span>
              <span class="time">{{ detail.create_time }}</span>
            </div>
            <h5 class="head_right">
              专栏：{{ detail.conf }}
            </h5>
          </div>
        </div>
        <div class="recommended_center" v-html="detail.content"></div>
        <div class="recommended_head" v-if="FileList">
          <div class="recommended_title flex_start">附件 </div>       
          <div class="recommended_head" style="border-bottom:0" v-for="(item, idx) in FileList" :key="idx">
            <div class="flex_between author">
              <span>{{ item.name }}</span>
              <a :href="item.file" download="filename" style="color:dodgerblue;">下载</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <!-- <Footer></Footer> -->
    <waterBox />
  </div>
</template>

<script>
import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
import Footer from "@/components/assembly/Footer.vue"; //尾部模块
import hot from "@/components/assembly/hot.vue"; //热门模块
import listLi from "@/components/assembly/listLi.vue"; //列表数据模块
import comments_li from "@/components/assembly/comments_li.vue"; //评论列表数据模块
import waterBox from "@/components/assembly/waterBox.vue";
import { AnalyticEmotion, Hashtable } from "@/assets/js/pcsinaFaceAndEffec.js";
import QRCode from "qrcodejs2";
import Hezuo from '@/components/tool/hezuo.vue'

import "@/assets/js/currency.js";
import "@/assets/css/reset.css";
import "@/assets/css/pcsinaFaceAndEffec.css";

export default {
  name: "column_details",
  data() {
    return {
      id: 0, //推文id
      detail: {}, //内容
      hotList_arr: [], //热门，
      FileList:{},
      comment_total: 0, //评论数量
      comment: [], //评论列表
      page: 1, //翻页
      keywords: "",
      pinlun: '',
      idloading: true,
      head_index: '',
    };
  },
  computed: {
    thousandBitSee: function () {
      //点赞数
      if (!this.detail.see) return 0;
      let num = this.detail.see;

      num = num.toString().split("."); // 分隔小数点
      var arr = num[0].split("").reverse(); // 转换成字符数组并且倒序排列
      var res = [];
      for (var i = 0, len = arr.length; i < len; i++) {
        if (i % 3 === 0 && i !== 0) {
          res.push(","); // 添加分隔符
        }
        res.push(arr[i]);
      }
      res.reverse(); // 再次倒序成为正确的顺序
      if (num[1]) {
        // 如果有小数的话添加小数部分
        res = res.join("").concat("." + num[1]);
      } else {
        res = res.join("");
      }
      return res;
    },
  },
  metaInfo() {
    return {
      meta: [{ name: "keywords", content: this.detail.seo }],
    };
  },
  components: {
    HeaderTop,
    Footer,
    hot,
    listLi,
    comments_li,
    Hezuo,
    waterBox
  },
  props: {},
  watch: {},
  methods: {
    //上传图片
    handleChange: function (e) {
      let _this = this;
      this.judgeUser();
      let images = "";
      var reader = new FormData();
      reader.append("file", e.target.files[0]);
      var layerOpen = layer.open({
        type: 2,
        content: "上传中。。。",
      });
      //发送图片消息
      $.ajax({
        type: "POST", //提交方式
        url: this.$URL + "upload", //路径
        data: reader,
        processData: false,
        contentType: false,
        success: function (result) {
          //返回数据根据结果进行相应的处理
          layer.close(layerOpen);
          _this.send(result.data, 2);
        },
      });
    },
    addImg() {
      $(".li_r_img img").on("click", function () {
        $(this).ImgZoomIn("");
      });
    },
    judgeUser() {
      //判断用户数据
      if (this.USER() && this.USER() !== {}) {
        this.REFRESH_USER();
      } else {
        this.$refs.header.promptShow();
      }
    },
    out: function () {
      //发送$(".inpu_div").val();
      var inputText = $(".inpu_div").val().trim()

      if (!inputText) {
        layer.open({
          content: "请输入内容",
          time: true,
          skin: "msg",
        });
        return false;
      }
      this.judgeUser();
      if (this.USER().is_words == 1) {
        layer.open({
          content: "你已被禁言!",
          time: true,
          skin: "msg",
        });
      } else {
        this.send(AnalyticEmotion(inputText), 1);
      }
    },
    send(content, type) {
      //发送评论
      let that = this;

      this.$post("comment", {
        news_id: this.id,
        member_id: this.USER().id,
        content: content,
        type: type,
      }).then((res) => {
        layer.open({
          content: "评论成功",
          time: true,
          skin: "msg",
        });
        $(".inpu_div").val('')
        setTimeout(() => {
          that.page = 1;
          that.getComment();
        }, 1000);
      });
    },
    collect(type) {
      //收藏
      let that = this;
      this.judgeUser();
      this.$post("collect", {
        member_id: this.USER().id,
        news_id: this.id,
        type: type,
      }).then((res) => {
        layer.open({
          content: type == 1 ? "收藏成功" : "取消收藏成功",
          time: true,
          skin: "msg",
        });
        that.detail.is_collect = that.detail.is_collect == 1 ? 0 : 1;
      });
    },
    give(type) {
      //点赞
      let that = this;
      this.$post("share_goods", { type: type, news_id: this.id }).then(
        (res) => {
          that.detail.goods = res.data;
        }
      );
    },
    detailsFun(id) {
      //查看详情
      this.$router.replace({ query: { id: id, head_index: this.head_index } });
      // this.$router.go(0)
      window.location.reload();
    },
    getDetails(id) {
      //获取详情
      let that = this;
      this.$get("content_detail", { news_id: id, member_id: this.USER().id })
        .then((res) => {
          that.detail = res.data.data;
          document.title = that.detail.title;
          that.FileList = JSON.parse(that.detail.fileList);
          that.$nextTick(() => {
            that.addImg();
          });
        })
        .catch((error) => {

          layer.open({
            content: error.message,
            time: 2,
            skin: "msg",
          });
          setTimeout(() => {
            that.$router.replace("/");
          }, 2000);
        });
    },
    goBackward() {
      //返回上一页
      this.$router.go(-1);
    },
    getComment() {
      //获取评论
      let that = this;
      if (that.page == 1) {
        this.comment = [];
      }
      this.$post("news_comment", {
        news_id: that.id,
        limit: 10,
        page: that.page,
      }).then((res) => {
        console.log(111111111111)
        that.comment_total = res.data.total;
        that.comment = res.data.data;
      });
    },
    getHotList() {
      //获取热门列表数据
      let that = this;
      this.$post("news_recomm", {
        type: 4,
        limit: 10,
        page: 1,
      }).then((res) => {
        let data = res.data.data;

        that.hotList_arr = data;
      });
    },
  },
  created() {
    this.idloading = true;
    // this.getSeo()
  },
  activated() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.idloading = true;
    // this.getSeo()
    this.head_index = this.$route.query.head_index - 0;
    this.id = this.$route.query.id;

    this.getDetails(this.$route.query.id);
    this.getHotList();
    this.getComment();
    this.idloading = false;
    $(".expression").SinaEmotion($(".inpu_div"));
    $(".expression").click(function () {
      $("#emotions").css({
        left: "50%",
        width: "436px",
        top: "50%",
        transform: "translate(-50%,-50%)",
        bottom: "auto",
        "z-index": "999",
      });
    });
    // this.$router.replace("/index");
    // if (this._isMobile()) {
    //   // alert("手机端");
    //   this.$router.replace("/m_column_details");
    // } else {
    //   this.$router.replace("/column_details");
    // }
    // let that = this;
    // $(window).scroll(function () {
    //   var scrollTop = $(this).scrollTop();
    //   var scrollHeight = $(document).height();
    //   var windowHeight = $(this).height();
    //   if (scrollTop + windowHeight + 2 >= scrollHeight) {
    //     that.page++;
    //     that.getComment();
    //   }
    // });
  },

  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    this.page = 1;
    this.comment = [];
    this.head_index = this.$route.query.head_index - 0;
    this.id = this.$route.query.id;
    // this.getDetails(this.$route.query.id);
    this.getHotList();
    this.getComment();
    this.idloading = false;
    $(".expression").SinaEmotion($(".inpu_div"));
    $(".expression").click(function () {
      $("#emotions").css({
        left: "50%",
        width: "436px",
        transform: "translate(-50%,-50%)",
        bottom: "auto",
        "z-index": "999",
      });
    });
    // this.$router.replace("/index");
    // if (this._isMobile()) {
    //   // alert("手机端");
    //   this.$router.replace("/m_column_details");
    // } else {
    //   this.$router.replace("/column_details");
    // }
    // let that = this;
    // $(window).scroll(function () {
    //   var scrollTop = $(this).scrollTop();
    //   var scrollHeight = $(document).height();
    //   var windowHeight = $(this).height();
    //   if (scrollTop + windowHeight + 2 >= scrollHeight) {
    //     that.page++;

    //     that.getComment();
    //   }
    // });
  },
};
</script>
<style>
</style>
<style scoped>
.main {
  max-width: 1280px;
  min-width: 865px;
  margin: 0 auto;
  width: 1280px;
}

#index {
  background: #f5f3fb;
  min-width: 1280px;
}

.main {
  padding: 13px 0;
  position: relative;
}

/* 标题 */
.recommended {
  background: #fff;
  border-radius: 10px;
  padding: 20px 51px;
}

.recommended .recommended_head {
  padding: 8px 0;
  border-bottom: 1px solid #999999;
  white-space: normal;
}

.recommended .recommended_head .recommended_title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  margin-bottom: 15px;
}

.recommended .recommended_head .recommended_title > .tag {
  border-radius: 4px;
  border: 2px solid #9749bb;
  color: #9749bb;
  font-size: 14px;
  margin-right: 10px;
  padding: 0 10px;
  line-height: 24px;
  height: 24px;
}

.recommended_head .head_bottom .original {
  font-size: 14px;
  color: #333;
  margin-right: 12px;
  /* letter-spacing: 1px; */
}

.recommended_head .head_bottom .time {
  font-size: 14px;
  color: #999;
}

.recommended_head .head_bottom .head_label {
  margin-left: 10px;
}

.recommended_head .head_bottom .head_label .label_li {
  font-size: 14px;
  color: #999;
  margin-left: 30px;
  line-height: 1em;
  cursor: pointer;
  position: relative;
}

.recommended_head .head_bottom .head_label .label_li > i {
  width: 15px;
  margin-right: 5px;
}

.recommended_head .head_bottom .head_label .label_li .share_div {
  position: absolute;
  bottom: 0;
  display: none;
  left: 50%;
  width: 150px;
  transform: translate(-50%, 110%);
  background: #fff;
  padding: 14px 14px 10px 14px;
  border-radius: 10px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.recommended_head .head_bottom .head_label .label_li .share_div::after {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  border-top: 10px transparent dashed;
  border-left: 10px transparent dashed;
  border-bottom: 10px transparent dashed;
  border-right: 10px #fff solid;
  transform: translate(-50%, -100%) rotate(90deg);
}
.spinner-box {
  width: 100%;
  height: 100vh;
  margin: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
.recommended_head
  .head_bottom
  .head_label
  .label_li.share_button:hover
  .share_div {
  display: block;
}

.recommended_head .head_bottom .head_right {
  font-size: 14px;
  color: #333;
}

.wx_saosao {
  margin-top: 6px;
  font-size: 14px;
  color: #858fa6;
}

/* 热门 */
.hot {
  width: 334px;
  background: #fff;
  border-radius: 10px;
  position: absolute;
  /* right: calc((100% - 1280px) / 2); */
  right: 0;
  top: 13px;
}

.hot .hot_title {
  border-bottom: 0.005rem solid #999999;
}

.hot .hot_title > i {
  width: 15px;
  margin-right: 11px;
}

.hot .hot_title > span {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  height: 70px;
}

/* 内容 */
.recommended_center {
  padding: 24px 0;
  line-height: 1.6em;
  font-size: 15px;
  border-bottom: 1px solid #dfdfdf;
}
.center_video {
  width: 100%;
}
.center_video > video {
  width: 100%;
}

/* 评论 */
.comments_div .comments_input {
  padding: 16px 0;
}

.comments_input .inpu_div {
  flex: 1;
  height: 38px;
  border-radius: 4px;
  border: 1px solid #999;
  font-size: 12px;
  margin-right: 17px;
  padding: 0 20px;
}

.comments_input .icon_img {
  width: 30px;
  cursor: pointer;
  margin: 0 17px 0 0;
}

.comments_input .icon_img.up_img {
  position: relative;
  display: flex;
}

.comments_input .icon_img.up_img .inp_img {
  position: absolute;
  top: 0;
  opacity: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  display: inline-block;
  cursor: pointer;
}

.comments_input .send {
  cursor: pointer;
  width: 81px;
  height: 38px;
  border-radius: 4px;
  border: 0;
  font-size: 16px;
  background: #fff;
  color: #ff5362;
  border: 2px solid #ff5362;
  transition: all 0.5s;
}
.comments_input .send:hover {
  background: #ff5362;
  color: #fff;
  border: 2px solid #ff5362;
}
.complete {
  padding: 60px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_viwe/content_details.vue